import React, { useEffect } from 'react';
import useNavigateWithParams from '../../hooks/useNavigateWithParams';
import { useAuth } from '../../context/AuthContext';
import './AuthCallback.css';

const AuthCallback = () => {
  const navigate = useNavigateWithParams();
  const { user, loading } = useAuth();

  useEffect(() => {
    // With Google OAuth popup flow, authentication happens in the popup
    // This page serves as a fallback/redirect handler
    if (!loading) {
      if (user) {
        navigate('/dashboard');
      } else {
        navigate('/login');
      }
    }
  }, [user, loading, navigate]);

  return (
    <div className="auth-callback">
      <div className="spinner"></div>
      <p>Completing authentication...</p>
    </div>
  );
};

export default AuthCallback;
